module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921114151_T.1262d465.jpg";